/**
 * firstPartyApps — the apps Prest0n connects through its OWN OAuth client instead of Composio's
 * (docs/PLAN-upwork-integration-20261009.md). Byte-identical twins, pinned equal by firstPartyAppsTwin.test.ts:
 *   functions/src/composio/firstPartyApps.ts   the server: the connect route and the card's lane
 *   src/services/composio/firstPartyApps.ts    the chat: the card, the connect click and the coach
 */
export const FIRST_PARTY_APPS = [{ slug: 'upwork', name: 'Upwork' }] as const;

export type FirstPartyApp = (typeof FIRST_PARTY_APPS)[number];

/** An app's name or slug → its first-party row, or null. Compares letters and digits only ("Up Work" is Upwork). */
export function firstPartyAppOf(nameOrSlug: unknown): FirstPartyApp | null {
  const key = String(nameOrSlug ?? '').toLowerCase().replace(/[^a-z0-9]/g, '');
  if (!key) return null;
  return FIRST_PARTY_APPS.find((a) => a.slug === key) || null;
}
